import { render } from "./Package.vue?vue&type=template&id=50450559"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"
script.render = render

export default script